import {
    Close as CloseIcon
} from '@mui/icons-material';
import { Card, Checkbox, CircularProgress, Grid, Icon, IconButton, InputLabel, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Tooltip } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDPeriodo from "components/MDPeriodo";
import MDButton from "components/MDButton";
import MDModalPerfis from "components/MDModalPerfis";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from 'context';
import { useUser } from "context/UserContext";
import DataTable from 'examples/Tables/DataTable';
import { Form, Formik } from "formik";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import PropTypes from "prop-types";
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { toDate, toDateTime } from "utils/DateUtils";
import { trueOrFalseEnum } from "utils/Enums";
import { errorAlert, formatarCpfCnpj, infoAviso, successAlert } from "utils/Functions";
import { post, postNoResponse } from 'utils/WebService';
import HistoryConsult from "views/history/HistoryConsult";
import * as Yup from "yup";
import PeopleCreateEdit from "./PeopleCreateEdit";
import { ESCURO } from "assets/coresTema";


const PeopleProcess = ({ id }) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(true);
    const [recordsTotal, setRecordsTotal] = useState(0);
    const [aplicar, setAplicar] = useState(false);
    const [isModalTable, setIsModalTable] = useState(false);
    const [dadosModalTable, setDadosModalTable] = useState(null);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [viewHistory, setViewHistory] = useState(false);

    const [openHistoryModal, setOpenHistoryModal] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [historyPage, setHistoryPage] = useState(0);
    const [historyTotalPages, setHistoryTotalPages] = useState(0);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [selectedProcessId, setSelectedProcessId] = useState(null);

    const [selectedRows, setSelectedRows] = useState([]);
    const [openBatchSuspension, setOpenBatchSuspension] = useState(false);
    const [isRemovingSuspension, setIsRemovingSuspension] = useState(false);

    const [batchMode, setBatchMode] = useState(null);

    const {
        tipoPartesEnum
    } = useUser();

    const tipoPartesEnumWithAll = [{
        id: null,
        name: "Todos",
        code: "todos",
    }, ...tipoPartesEnum];

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        nome: null,
        tipoParte: null,
        suspenso: null,
        documento: null,
    });

    useEffect(() => {
        if (id) {
            fetchDataPeople({ ...tableState });
        }
    }, [id]);

    const handleCheckboxChange = (event, id) => {
        setSelectedRows((prev) => {
            const updated = new Set(prev);
            if (event.target.checked) {
                updated.add(id);
            } else {
                updated.delete(id);
            }
            return Array.from(updated);
        });
    };

    const columns = [
        ...(batchMode !== null ? [{
            header: () => {
                if (batchMode === null) return null;

                const eligibleRows =
                    batchMode === "unsuspend"
                        ? data.filter(row => row.suspenso)
                        : data;

                const allEligibleIds = eligibleRows.map(row => row.id);

                const someSelected = allEligibleIds.some(id =>
                    selectedRows.includes(id)
                );
                const allSelected =
                    eligibleRows.length > 0 &&
                    allEligibleIds.every(id => selectedRows.includes(id));

                return (
                    <MDBox display="flex" justifyContent="center">
                        <Checkbox
                            indeterminate={someSelected && !allSelected}
                            checked={allSelected}
                            onChange={(e) => {
                                setSelectedRows(prev => {
                                    const current = new Set(prev);

                                    if (e.target.checked) {
                                        allEligibleIds.forEach(id => current.add(id));
                                    } else {
                                        allEligibleIds.forEach(id => current.delete(id));
                                    }

                                    return Array.from(current);
                                });
                            }}
                        />
                    </MDBox>
                );
            },

            accessorKey: "id",
            cell: info => {
                const row = info.row.original;
                const disabled =
                    batchMode === "unsuspend" && !row.suspenso;

                return batchMode !== null ? (
                    <Tooltip title={disabled ? "Não está suspenso" : ""}>
                        <MDBox display="flex" justifyContent="center" >
                            <Checkbox
                                checked={selectedRows.includes(info.getValue())}
                                onChange={(e) => handleCheckboxChange(e, info.getValue())}
                                disabled={disabled}
                            />
                        </MDBox>
                    </Tooltip>
                ) : null;
            },
            width: "1%",
            align: "center"
        }] : []),
        {
            header: "nome",
            accessorKey: "nome",
            cell: info => <DefaultCell>{info.getValue() || ""}</DefaultCell>,
            isSorted: true
        },
        {
            header: "documento",
            accessorKey: "documento",
            cell: info => <DefaultCell>{formatarCpfCnpj(info.getValue()) || "-"}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Data da suspensão",
            accessorKey: "dataSuspensao",
            cell: info => <DefaultCell>{toDate(info.getValue()) || "-"}</DefaultCell>,
            isSorted: true
        },
        {
            header: "suspenso",
            accessorKey: "suspenso",
            width: "7%",
            cell: info => (
                <Checkbox
                    checked={info.getValue() || false}
                    disabled
                    color="primary"
                    inputProps={{ 'aria-label': 'Ativo' }}
                />
            ),
            isSorted: false,
        },
        {
            header: "tipo parte",
            accessorKey: "tipoParte",
            cell: info => {
                const status = tipoPartesEnum?.find(ht => ht.code === info.getValue())
                return (
                    <DefaultCell>{status?.name || ""}</DefaultCell>
                )
            },
            isSorted: true
        },
        {
            header: "advogados",
            isSorted: false,
            cell: info => {
                const adv = info.row.original.advogados;
                return (
                    adv?.length > 0 && (
                        <Tooltip title="Advogados">
                            <IconButton
                                onClick={() => {
                                    setDadosModalTable(info.row.original.advogados);
                                    setIsModalTable(true);
                                }}>
                                <MDTypography variant="h4">
                                    <Icon color="inherit" sx={{ marginRight: 1 }}>group</Icon>
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                    )
                )
            },
            width: "15%"
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <>
                    <Tooltip title="Editar">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original.id);
                                setIsCreateEdit(true);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>edit</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Remover">
                        <IconButton
                            onClick={() => {
                                handleDelete(info.row.original.id);
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="error" sx={{ marginRight: 1 }}>delete</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Log">
                        <IconButton
                            onClick={() => {
                                setSelectedId(info.row.original.id)
                                setViewHistory(true)
                            }}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>search</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Histórico de causa">
                        <IconButton
                            onClick={() => handleOpenHistory(info.row.original.id)}>
                            <MDTypography variant="h4">
                                <Icon color="inherit" sx={{ marginRight: 1 }}>article</Icon>
                            </MDTypography>
                        </IconButton>
                    </Tooltip>
                </>
            ),
            width: "15%"
        },
    ];

    const fetchDataPeople = useCallback(({ pageSize, pageIndex, sorting, filtered, nome, tipoParte, documento, suspenso }) => {
        setLoadingTable(true);
        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: (filtered && filtered.length > 0) ? filtered : tableState.current.filtered,
            nome: (nome || nome == "") ? nome : tableState.current.nome,
            tipoParte: (tipoParte || tipoParte?.code == "todos") ? tipoParte?.id : tableState.current.tipoParte,
            documento: documento === "" ? null : (documento ?? tableState.current.documento),
            suspenso: suspenso !== undefined ? suspenso : tableState.current.suspenso,
        };

        tableState.current = updatedTableState;

        post("/processo-parte/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            filtered: updatedTableState.filtered,
            processoId: id,
            nome: updatedTableState.nome,
            tipoParte: updatedTableState.tipoParte,
            documento: updatedTableState.documento,
            suspenso: updatedTableState.suspenso,

        }).then(({ data, pages, recordsTotal }) => {
            setPages(pages);
            setData(data);
            setRecordsTotal(recordsTotal);
            setLoadingTable(false);
            setAplicar(false);
        }).catch(() => {
            setLoadingTable(false)
            setAplicar(false);
        });
    }, []);

    const handleDelete = (id) => {
        infoAviso(
            "Deseja realmente deletar essa parte do processo?",
            async () => {
                await removePerson(id);
            },
            () => {
                return;
            }
        );
    };

    const removePerson = async (id) => {
        if (id) {
            postNoResponse(`/processo-parte/delete/${id}`)
                .then(() => {
                    successAlert("Parte removida com sucesso!", () => null);
                    fetchDataPeople({ ...tableState });
                })
                .catch(e => {
                    console.error(e)
                    errorAlert("Erro ao remover parte");
                })
        }
    }

    const handleCloseModal = () => {
        setIsModalTable(false);
        setDadosModalTable(null);
    };

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
        setViewHistory(false)
    }

    const handleRefresh = () => {
        fetchDataPeople({ ...tableState });
    };

    function handleAddPerson() {
        setIsCreateEdit(true);
        setSelectedId(null);
    };

    const handleApplyFilter = (values) => {
        setAplicar(true)
        fetchDataPeople({
            ...tableState,
            nome: values?.nome,
            tipoParte: values?.tipoParte,
            documento: values?.documento,
            suspenso: values?.suspenso,
        });
    };

    const handleCleanFilter = () => {
        let updatedTableState = {}
        setData([])
        updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            nome: null,
            tipoParte: null,
            documento: null,
            suspenso: null
        };
        tableState.current = updatedTableState;
        fetchDataPeople({
            ...tableState.current
        });

    };

    const handleOpenHistory = async (processId) => {
        setSelectedProcessId(processId);
        setOpenHistoryModal(true);
        setHistoryPage(0);
        await fetchHistory(processId, 0);
    };

    const fetchHistory = async (processId, page) => {
        setHistoryLoading(true);
        try {
            const response = await post("/historico-processo-parte/list", {
                page,
                pageSize: 10,
                sorted: [],
                filtered: [],
                processoParteId: processId,
            });
            setHistoryData(response.data);
        } catch (err) {
            console.error(err);
            errorAlert("Erro ao carregar histórico da causa.");
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleChangePage = (newPage) => {
        setHistoryPage(newPage);
        fetchHistory(selectedProcessId, newPage);
    };

    const handleCloseHistory = () => {
        setOpenHistoryModal(false);
        setHistoryData([]);
    };

    const handleBatchAction = async (values) => {
        const isSuspend = batchMode === "suspend";
        if (!isSuspend) setIsRemovingSuspension(true);

        try {
            await postNoResponse("/processo-parte/batch-suspension", {
                dataSuspensao: isSuspend ? values.dataSuspensao : null,
                dataFimSuspensao: isSuspend ? values.dataFimSuspensao : null,
                motivo: isSuspend ? values.motivo : null,
                qtdDiasAvisoSuspensao: isSuspend ? values.qtdDiasAvisoSuspensao : null,
                suspenso: isSuspend,
                casoProcessualId: id,
                pessoasIds: selectedRows
            });

            successAlert(
                isSuspend ? "Suspensão aplicada!" : "Suspensão removida!"
            );

            setBatchMode(null);
            setSelectedRows([]);
            fetchDataPeople({ ...tableState });

        } catch {
            errorAlert(
                isSuspend ? "Erro ao suspender em lote" : "Erro ao remover suspensão"
            );
        } finally {
            setOpenBatchSuspension(false);
            if (!isSuspend) setIsRemovingSuspension(false);
        }
    };

    return (
        <Card id="people-process">
            {isModalTable &&
                <MDModalPerfis
                    dados={dadosModalTable}
                    show={isModalTable}
                    close={handleCloseModal}
                    header={"Advogados"}
                />
            }

            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <PeopleCreateEdit
                        id={selectedId}
                        closeCreateEdit={backFunction}
                        refreshTable={handleRefresh}
                        casoProcessualId={id} />
                </Grid>
            }

            <Modal
                open={openHistoryModal}
                onClose={handleCloseHistory}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Card
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        borderRadius: 4,
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <MDTypography variant="h6">Histórico das Partes do Processo</MDTypography>
                        <IconButton
                            onClick={handleCloseHistory}
                            size="small"
                            sx={{ color: darkMode ? '#fff' : '#000' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </MDBox>

                    {historyLoading ? (
                        <MDBox
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            height="300px"
                            flexDirection="column"
                        >
                            <CircularProgress color="info" size={50} />
                            <MDTypography variant="body2" mt={2}>
                                Carregando histórico...
                            </MDTypography>
                        </MDBox>
                    ) : (
                        <>
                            <MDTypography variant="body2" mb={2}>
                                {historyData.length > 0
                                    ? `Total de ${historyData.length} registro${historyData.length !== 1 ? 's' : ''}`
                                    : 'Nenhum registro encontrado.'}
                            </MDTypography>

                            <TableContainer
                                component={Paper}
                                sx={{
                                    overflowX: 'auto',
                                    backgroundColor: darkMode ? ESCURO.painelEscuro : '#fff',
                                    border: 'none',
                                    boxShadow: 'none',
                                }}
                            >
                                <Table stickyHeader size="small">
                                    <TableRow sx={{ backgroundColor: darkMode ? '#192641ff' : '#f5f5f5' }}>
                                        {[
                                            'Procurador',
                                            'Tipo Usuário',
                                            'Status',
                                            'Tipo Substabelecimento',
                                            'Data Inclusão',
                                            'Data Desativação',
                                            'Para Quem',
                                            'Quem Fez',
                                        ].map((col) => (
                                            <TableCell
                                                key={col}
                                                align="center"
                                                sx={{ color: darkMode ? '#fff' : '#000' }}
                                            >
                                                {col}
                                            </TableCell>
                                        ))}
                                    </TableRow>

                                    <TableBody>
                                        {historyData.map((h, index) => {
                                            const dataInclusao = toDateTime(h.dataInclusao, true);
                                            const dataDesativacao = h.dataDesativacao
                                                ? toDateTime(h.dataDesativacao, true)
                                                : '-';
                                            const bgColor = darkMode
                                                ? index % 2 === 0
                                                    ? '#1a2235ff'
                                                    : '#26324dff'
                                                : index % 2 === 0
                                                    ? '#fff'
                                                    : '#f9f9f9';
                                            const textColor = darkMode ? '#fff' : '#000';

                                            return (
                                                <TableRow key={h.id || index} sx={{ backgroundColor: bgColor }}>
                                                    {[
                                                        h.procurador,
                                                        h.tipoUsuario,
                                                        h.status,
                                                        h.tipoSubstabelecimento,
                                                        dataInclusao,
                                                        dataDesativacao,
                                                        h.paraQuem,
                                                        h.quemFez,
                                                    ].map((val, idx) => (
                                                        <TableCell key={idx} align="center" sx={{ color: textColor }}>
                                                            {val || '-'}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <MDBox display="flex" justifyContent="center" alignItems="center" mt={2} gap={2}>
                                <MDButton
                                    variant="outlined"
                                    color="info"
                                    disabled={historyPage === 0}
                                    onClick={() => handleChangePage(historyPage - 1)}
                                >
                                    Anterior
                                </MDButton>

                                <MDTypography variant="body2">
                                    Página {historyPage + 1} de {historyTotalPages + 1}
                                </MDTypography>

                                <MDButton
                                    variant="outlined"
                                    color="info"
                                    disabled={historyPage + 1 >= historyTotalPages}
                                    onClick={() => handleChangePage(historyPage + 1)}
                                >
                                    Próxima
                                </MDButton>
                            </MDBox>
                        </>
                    )}
                </Card>
            </Modal>


            <Modal
                open={openBatchSuspension}
                onClose={() => setOpenBatchSuspension(false)}
            >
                <Card sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: "70%",
                    borderRadius: 4,
                    boxShadow: 24,
                    p: 4,
                    maxWidth: "600px",
                }}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <MDTypography variant="h6">Suspender Pessoas em Lote</MDTypography>
                        <IconButton onClick={() => setOpenBatchSuspension(false)}>
                            <CloseIcon />
                        </IconButton>
                    </MDBox>

                    <Formik
                        initialValues={{
                            dataSuspensao: "",
                            dataFimSuspensao: "",
                            motivo: "",
                            qtdDiasAvisoSuspensao: "",
                        }}
                        validationSchema={batchSuspensionSchema}
                        onSubmit={async (values, actions) => {
                            await handleBatchAction(values);
                            actions.setSubmitting(false);
                        }}
                    >
                        {({ values, errors, touched, setFieldValue, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <MDPeriodo label="Período da Suspensão" inicio={values.dataSuspensao} fim={values.dataFimSuspensao}
                                            onChange={({ inicio, fim }) => { setFieldValue("dataSuspensao", inicio); setFieldValue("dataFimSuspensao", fim); }} />
                                        {((errors.dataSuspensao && touched.dataSuspensao) || (errors.dataFimSuspensao && touched.dataFimSuspensao)) && (
                                            <MDTypography variant="caption" color="error" fontWeight="bold">
                                                {errors.dataSuspensao || errors.dataFimSuspensao}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Motivo</InputLabel>
                                        <MDInput
                                            size="small"
                                            name="motivo"
                                            multiline
                                            rows={4}
                                            fullWidth
                                            value={values.motivo}
                                            onChange={(e) => setFieldValue("motivo", e.target.value)}
                                           
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Dias de antecedência</InputLabel>
                                        <MDInput
                                            size="small"
                                            name="qtdDiasAvisoSuspensao"
                                            type="number"
                                            fullWidth
                                            value={values.qtdDiasAvisoSuspensao}
                                            onChange={(e) => setFieldValue("qtdDiasAvisoSuspensao", e.target.value)}
                                            error={Boolean(errors.qtdDiasAvisoSuspensao && touched.qtdDiasAvisoSuspensao)}
                                        />
                                        {errors.qtdDiasAvisoSuspensao && touched.qtdDiasAvisoSuspensao && (
                                            <MDTypography variant="caption" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
                                                {errors.qtdDiasAvisoSuspensao}
                                            </MDTypography>
                                        )}
                                    </Grid>
                                </Grid>


                                <MDBox display="flex" justifyContent="end" mt={3}>
                                    <MDButton
                                        disabled={isSubmitting}
                                        size="large"
                                        variant="contained"
                                        color="info"
                                        circular={false}
                                        iconOnly={false}
                                        type="submit"
                                        endIcon={
                                            isSubmitting ? (
                                                <CircularProgress color="inherit" size={20} sx={{ ml: 0, mr: 0 }} />
                                            ) : null
                                        }
                                    >
                                        {!isSubmitting && "Enviar Suspensão"}
                                    </MDButton>

                                </MDBox>
                            </Form>
                        )}
                    </Formik>
                </Card>
            </Modal>

            {viewHistory &&
                <Grid item xs={12} md={12}>
                    <HistoryConsult
                        nomeEntidade="c044"
                        idEntidade={selectedId}
                        closeCreateEdit={backFunction} />
                </Grid>
            }

            <Grid item xs={12} md={12} sx={{ display: isCreateEdit || viewHistory ? "none" : "" }}>
                <MDBox p={2}>
                    <Formik
                        initialValues={{
                            nome: null,
                            tipoParte: null,
                            documento: null,
                            suspenso: null,
                        }}
                        onSubmit={(values) => handleApplyFilter(values)}>
                        {({ values, setFieldValue, resetForm }) => {
                            return (
                                <Form>
                                    <Grid container spacing={2} pt={2}>
                                        <Grid item xs={3} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome</InputLabel>
                                            <MDInput
                                                size="small"
                                                placeholder="Informe o nome..."
                                                value={values.nome ?? ""}
                                                onChange={({ target }) => setFieldValue("nome", target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleApplyFilter(values);
                                                    }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={3} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Documento</InputLabel>
                                            <MDInput
                                                size="small"
                                                placeholder="Informe o CPF ou CNPJ..."
                                                value={values.documento ?? ""}
                                                onChange={({ target }) => setFieldValue("documento", target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleApplyFilter(values);
                                                    }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo da Parte</InputLabel>
                                            <MDSelect
                                                isMulti={false}
                                                getOptionValue={option => option.code}
                                                getOptionLabel={option => option.name}
                                                name="tipo-multi-select"
                                                placeholder="Todos"
                                                value={values.tipoParte}
                                                options={tipoPartesEnumWithAll}
                                                onChange={selectedOptions =>
                                                    setFieldValue("tipoParte", selectedOptions)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Suspenso</InputLabel>
                                            <MDSelect
                                                isMulti={false}
                                                getOptionValue={(option) => option.id}
                                                getOptionLabel={(option) => option.name}
                                                name="suspenso"
                                                placeholder="Ambos"
                                                value={trueOrFalseEnum.find(({ value }) => value == values.suspenso) || null}
                                                options={trueOrFalseEnum}
                                                onChange={(selected) => {
                                                    setFieldValue("suspenso", selected?.value ?? null);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} display='flex' justifyContent='space-between'>
                                            <Grid item xs={12} sm={12} textAlign="left" style={{ display: 'flex', gap: 15 }}>
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={handleAddPerson}
                                                >
                                                    Adicionar Pessoa
                                                </MDButton>

                                            </Grid>

                                            <Grid item xs={12} sm={12} textAlign="right">
                                                <MDButton
                                                    size="medium"
                                                    sx={{ marginRight: 2 }}
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    onClick={() => {
                                                        resetForm({
                                                            values: {
                                                                ...values,
                                                                nome: null,
                                                                tipoParte: null,
                                                                documento: null,
                                                                suspenso: null,
                                                            },
                                                        });
                                                        handleCleanFilter();
                                                    }}
                                                >
                                                    Limpar filtro
                                                </MDButton>
                                                <MDButton
                                                    size="medium"
                                                    variant="contained"
                                                    color="info"
                                                    circular={false}
                                                    iconOnly={false}
                                                    type="submit"
                                                >
                                                    Aplicar filtro
                                                </MDButton>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} textAlign="left" style={{ display: 'flex', gap: 15 }}>

                                            <MDButton
                                                variant="contained"
                                                color="info"
                                                onClick={() => {
                                                    setSelectedRows([]);
                                                    setBatchMode(batchMode === "suspend" ? null : "suspend");
                                                }}
                                                disabled={batchMode === "unsuspend"}
                                            >
                                                {batchMode === "suspend"
                                                    ? "Cancelar"
                                                    : "Suspender"}
                                            </MDButton>

                                            <MDButton
                                                variant="contained"
                                                color="info"
                                                onClick={() => {
                                                    setSelectedRows([]);
                                                    setBatchMode(batchMode === "unsuspend" ? null : "unsuspend");
                                                }}
                                                disabled={batchMode === "suspend"}
                                            >
                                                {batchMode === "unsuspend"
                                                    ? "Cancelar"
                                                    : "Remover Suspensão"}
                                            </MDButton>

                                        </Grid>
                                    </Grid>
                                </Form>
                            )
                        }}
                    </Formik>
                </MDBox>
                <MDBox p={2}>
                    <DataTable
                        loading={loadingTable}
                        columnData={columns}
                        data={data}
                        fetchData={fetchDataPeople}
                        totalPages={pages}
                        totalRecords={recordsTotal}
                        changeFilter={aplicar}
                        tableState={tableState}
                        getRowStyle={(row) => ({
                            backgroundColor: row.original.proxSuspensao ? "#ff00001f" : "transparent",
                        })}
                    />
                    {selectedRows.length > 0 && batchMode === "suspend" && (
                        <MDButton
                            size="medium"
                            variant="contained"
                            color="success"
                            onClick={() => setOpenBatchSuspension(true)}>
                            Confirmar Suspensão
                        </MDButton>
                    )}

                    {selectedRows.length > 0 && batchMode === "unsuspend" && (
                        <MDButton
                            disabled={isRemovingSuspension}
                            size="large"
                            variant="contained"
                            color="error"
                            circular={false}
                            iconOnly={false}
                            onClick={() => handleBatchAction({})}
                            endIcon={
                                isRemovingSuspension ? (
                                    <CircularProgress color="inherit" size={20} sx={{ ml: 0, mr: 0 }} />
                                ) : null
                            }
                        >
                            {!isRemovingSuspension && "Confirmar Remoção"}
                        </MDButton>
                    )}

                </MDBox>
            </Grid>
        </Card>
    );
};

PeopleProcess.propTypes = {
    id: PropTypes.string,
};

const batchSuspensionSchema = Yup.object().shape({
    dataSuspensao: Yup.date().typeError('Data inválida').required("Data de início é obrigatória"),
    dataFimSuspensao: Yup.date().typeError('Data inválida').required("Data fim é obrigatória")
        .min(Yup.ref('dataSuspensao'), "Data limite não pode ser anterior ao início"),
    qtdDiasAvisoSuspensao: Yup.number().typeError('Apenas números').required("Dias obrigatórios")
        .min(0, "Não pode ser negativo")
        .test(
            'valid-duration',
            'Os dias de aviso não podem exceder os dias totais da suspensão',
            function (value) {
                const { dataSuspensao, dataFimSuspensao } = this.parent;
                if (!dataSuspensao || !dataFimSuspensao || typeof value !== 'number') return true;
                
                const start = new Date(dataSuspensao);
                const end = new Date(dataFimSuspensao);
                if (start > end) return true; // Já bloqueado pelo Yup da dataFim
                
                const diffDays = Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
                return value <= diffDays;
            }
        ),
});

export default memo(PeopleProcess);

